import React from 'react';
import bespokeServerAppMockups4Html from './bespokeServerAppMockups4Html';

const BespokeServerAppMockups4: React.FC = () => {
  return (
    <iframe
      srcDoc={bespokeServerAppMockups4Html}
      title="Bespoke Server App — Style Explorations"
      style={{ width: '100%', height: '100vh', border: 'none' }}
    />
  );
};

export default BespokeServerAppMockups4;
